import { interfaceError } from '../../i18n/errorMessages';
import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { localizeSystemText } from '../../i18n/messages';

export default function LocalizedMessage({ value, isError }) {
  const { t } = useTranslation();
  return <>{localizeSystemText(isError && value ? interfaceError(value) : value, t)}</>;
}

LocalizedMessage.propTypes = {
  isError: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({ key: PropTypes.string.isRequired, params: PropTypes.object })]),
};
LocalizedMessage.defaultProps = { value: '', isError: false };
